import React from 'react';
import PropTypes from 'prop-types';
import { designSystem, Modal, Panel, PanelGroup } from '@yola/ws-ui';
import bowser from 'yola-bowser';
import Breadcrumbs from 'src/js/modules/common/components/breadcrumbs';
import constants from '../constants';

const {
  ControlGroup,
  Checkbox,
  DialogHeader,
  Box,
  Stack,
  DialogButtonGroup,
  DialogButton,
  Paragraph,
  Heading,
  DialogButtonGroupSeparator,
} = designSystem;

const {
  DEFAULT_OFFSET_X,
  DEFAULT_OFFSET_Y,
  DEFAULT_DIALOG_HEIGHT,
  DEFAULT_DIALOG_WIDTH,
  DEFAULT_DIALOG_MIN_HEIGHT,
} = constants;

function DesignEffectsDialog({
  captions,
  isWebsiteAnimationChecked,
  onWebsiteAnimationChange,
  onSubmit,
  onCancel,
}) {
  return (
    <Modal
      draggable
      fullscreen={bowser.mobile}
      width={DEFAULT_DIALOG_WIDTH}
      minWidth={DEFAULT_DIALOG_WIDTH}
      maxWidth={DEFAULT_DIALOG_WIDTH}
      height={DEFAULT_DIALOG_HEIGHT}
      minHeight={DEFAULT_DIALOG_MIN_HEIGHT}
      offsetX={DEFAULT_OFFSET_X}
      offsetY={DEFAULT_OFFSET_Y}
      dragHandleSelector=".ws-drag-trigger"
      dragCancelSelector=".ws-ui-dialog-header-controls"
      overlay="none"
      resizeIcon="ns-resize"
      handleCancel={onCancel}
      handleSubmit={onSubmit}
      onOverlayClick={onSubmit}
      className="ws-design-effects-dialog"
    >
      <PanelGroup height="100%">
        <Panel
          align="middle"
          corners="squared"
          className="ws-drag-trigger"
          style={{ flexShrink: '0' }}
        >
          <DialogHeader paddingBottom="spacing-s">
            <Box>
              <Box paddingBottom="spacing-2-xs">
                <Breadcrumbs breadcrumbs={captions.breadcrumbs} />
              </Box>
              <Box>
                <Stack>
                  <Heading type="heading-3">{captions.title}</Heading>
                  <Paragraph>{captions.description}</Paragraph>
                </Stack>
              </Box>
            </Box>
          </DialogHeader>
        </Panel>
        <Panel height="100%" scrollable style={{ borderBottom: 'none' }}>
          <Box
            paddingTop="spacing-s"
            paddingBottom="spacing-s"
            paddingLeft="spacing-m"
            paddingRight="spacing-m"
          >
            <Stack>
              <div className="ws-design-effects-dialog__content">
                <div className="ws-design-effects-dialog__image">
                  <img src="/images/effects-preview.gif" alt="" />
                </div>
                <ControlGroup
                  title={captions.animationTitle}
                  description={captions.animationDescription}
                >
                  <Checkbox
                    id="enableWebsiteAnimation"
                    label={captions.animationLabel}
                    checked={isWebsiteAnimationChecked}
                    onChange={onWebsiteAnimationChange}
                    value="website-animation"
                  />
                </ControlGroup>
              </div>
            </Stack>
          </Box>
        </Panel>
        <Panel corners="squared" style={{ flexShrink: '0' }}>
          <DialogButtonGroup>
            <DialogButton onClick={onSubmit}>{captions.submitButton}</DialogButton>
            <DialogButtonGroupSeparator />
            <DialogButton onClick={onCancel}>{captions.cancelButton}</DialogButton>
          </DialogButtonGroup>
        </Panel>
      </PanelGroup>
    </Modal>
  );
}

DesignEffectsDialog.propTypes = {
  captions: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    description: PropTypes.string,
    animationTitle: PropTypes.string,
    animationDescription: PropTypes.string,
    animationLabel: PropTypes.string,
    submitButton: PropTypes.string,
    cancelButton: PropTypes.string,
  }).isRequired,
  isWebsiteAnimationChecked: PropTypes.bool.isRequired,
  onWebsiteAnimationChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default DesignEffectsDialog;
